// extracted by mini-css-extract-plugin
export default {"checkSelf":"checkSelf--TDPVi","permissionSelector":"permissionSelector--pF4Mx","leftTop":"leftTop--l2yYT","content":"content--HdBCe","userInfo":"userInfo--qt3lC"};